import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "q-pa-md" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h5", null, [
  /*#__PURE__*/_createTextVNode("Whitelisted IPs"),
  /*#__PURE__*/_createElementVNode("span", { class: "text-subtitle1" }, " - no restrictions during login process to administrative panel")
], -1)
const _hoisted_3 = { class: "row q-gutter-md q-mb-lg" }
const _hoisted_4 = /*#__PURE__*/_createTextVNode("Show whitelisted IP")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_q_input = _resolveComponent("q-input")!
  const _component_q_tooltip = _resolveComponent("q-tooltip")!
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_td = _resolveComponent("q-td")!
  const _component_q_table = _resolveComponent("q-table")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_q_input, {
        outlined: "",
        dense: "",
        name: "search",
        modelValue: _ctx.filter,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.filter) = $event)),
        color: "primary",
        label: "Search by IP or description",
        clearable: "",
        class: "col-grow"
      }, {
        append: _withCtx(() => [
          _createVNode(_component_q_icon, { name: "search" })
        ]),
        _: 1
      }, 8, ["modelValue"])
    ]),
    _createVNode(_component_q_table, {
      columns: _ctx.whitelistedIPsColumns,
      rows: _ctx.filteredWhiteListedIps,
      pagination: _ctx.pagination,
      "onUpdate:pagination": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.pagination) = $event)),
      flat: "",
      "wrap-cells": ""
    }, {
      "body-cell-actions": _withCtx((props) => [
        _createVNode(_component_q_td, { props: props }, {
          default: _withCtx(() => [
            _createVNode(_component_q_btn, {
              dense: "",
              round: "",
              flat: "",
              color: "grey",
              onClick: ($event: any) => (_ctx.onShowWhitelistedIP(null, props.row)),
              icon: "pageview"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_q_tooltip, null, {
                  default: _withCtx(() => [
                    _hoisted_4
                  ]),
                  _: 1
                })
              ]),
              _: 2
            }, 1032, ["onClick"])
          ]),
          _: 2
        }, 1032, ["props"])
      ]),
      _: 1
    }, 8, ["columns", "rows", "pagination"])
  ]))
}